import {
  Box,
  Typography,
  Chip,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';

const AddLegDialog = ({ open, onClose, rotationCode, flights, search, onSearchChange, highlight, onHighlightChange, onAddLeg }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Add Flight — {rotationCode}</DialogTitle>

    <DialogContent>
      <TextField
        fullWidth
        size="small"
        label="Search flight / airport"
        value={search}
        autoFocus
        onChange={(e) => { onSearchChange(e.target.value); onHighlightChange(0); }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            onHighlightChange(Math.min(highlight + 1, Math.min(flights.length, 60) - 1));
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            onHighlightChange(Math.max(highlight - 1, 0));
          } else if (e.key === 'Enter') {
            e.preventDefault();
            const f = flights[highlight];
            if (f) onAddLeg(f._id);
          }
        }}
        placeholder="Flight no, DEP, ARR…"
        sx={{ mb: 1 }}
      />

      <Box sx={{ height: 360, overflowY: 'auto' }}>
        <List dense disablePadding>
          {flights.slice(0, 60).map((f, idx) => (
            <ListItemButton key={f._id} selected={idx === highlight} onClick={() => onAddLeg(f._id)}>
              <ListItemText
                primary={
                  <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="body2" fontWeight="bold" fontFamily="monospace">{f.carrier}{f.flightNo}</Typography>
                    <Typography variant="body2" fontFamily="monospace">{f.dep}→{f.arr}</Typography>
                    <Typography variant="body2" color="text.secondary" fontFamily="monospace">
                      {f.std}–{f.sta}{f.nextDay ? `+${f.nextDay}` : ''}
                    </Typography>
                  </Box>
                }
                secondary={
                  <Box display="flex" gap={0.5} mt={0.2}>
                    {f.acType && <Chip label={f.acType} size="small" />}
                    <Chip label={f.daysOfOperation || '-'} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: '0.6rem' }} />
                    {f.blockTime > 0 && (
                      <Chip
                        label={`${Math.floor(f.blockTime / 60)}h${String(f.blockTime % 60).padStart(2, '0')}m`}
                        size="small" variant="outlined" sx={{ fontSize: '0.6rem' }}
                      />
                    )}
                  </Box>
                }
              />
            </ListItemButton>
          ))}
          {flights.length === 0 && (
            <Box py={3} textAlign="center">
              <Typography variant="body2" color="text.secondary">No flights found.</Typography>
            </Box>
          )}
        </List>
      </Box>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default AddLegDialog;
